<div class="trade-charts d-flex flex-column">
  <ng-container *ngIf="!showWarningMessage">
    <div class="col-12 mb-1">
      <app-billet-position *ngIf="!loading && !showConfirmationBillit" [position]="listPosition" [dense]="true">
      </app-billet-position>
    </div>
    <div class="col-12 p-0" *ngIf="!loading && !showConfirmationBillit">
      <div class="sized">
        <app-incremental-input-small [withBackground]="true" placeholder="Quantidade" name="model.qtd"
          ondragstart="return false;" ondrop="return false;" [roundLot]="model.loteDefault" [maxlength]="7"
          (mousewheel)="verifyQuantity()" [invalid]="qtdValid" minValue="0" maxValue="999999"
          (keydown)="validPrice(model.qtd)" (keyup)="verifyQuantity(); validPrice(model.qtd);"
          (click)="verifyQuantity()" [isQuantity]="true" [(ngModel)]="model.qtd" aria-required="" [price]="false"
          [isDisabled]="!quantityDisabled()">
        </app-incremental-input-small>
      </div>
      <div class="sized">
        <app-incremental-input [withBackground]="true" name="model.price" ondragstart="return false;" id="preço"
          ondrop="return false;" placeholder="Preço" (keyup)="validPrice(model.price)" (keyup)="verifyQuantity()"
          (valueChanged)="validPrice(model.price);verifyQuantity()" maxValue="999999" [minValue]="0"
          [options]="indiceFuture ? priceValuesFormatOptionsFuture : priceValuesFormatOptions"
          [roundLot]="+model.minimumIncrement" minValue="0" [isQuantity]="true" [price]="true" [(ngModel)]="model.price"
          aria-required="">
        </app-incremental-input>
      </div>
      <div class="col-12">
        <app-billet-actions (actionConfirm)="confirmTradeAction($event)" [isBilletChart]="true" [dense]="true"
          [statusOmsOnline]="statusOmsOnline" [isLoggedNegotiation]="isLoggedNegotiation" [termOperator]="termOperator"
          [positionNetDay]="listPosition?.netDay" [asset]="model?.quote" [market]="model?.market"
          (openConfirmationBillit)="openModalConfirm($event)">
        </app-billet-actions>
      </div>
    </div>
    <div *ngIf="showConfirmationBillit">
      <app-billet-wks-confirmation class="col-12" [model]="model" [indiceFuture]="indiceFuture" [lastTrade]="lastTrade"
        (loading)="setLoading($event)" (openConfirmationBillit)="closeModalConfirm($event)" [isBilletFloat]="true">
      </app-billet-wks-confirmation>
    </div>
    <div class="confirmation-billet" *ngIf="!loading && showConfirmationBillit && isLoggedNegotiation">
      <div class="confirmation-header">
        <mat-icon disableWksChange svgIcon="close" (click)="close()" matTooltipPosition="above"
          [matTooltip]="cancelTooltip">
        </mat-icon>
      </div>
      <app-billet-wks-confirmation [model]="model" [indiceFuture]="indiceFuture" [lastTrade]="price"
        (openTermOperator)="openModalConfirm($event)" (openConfirmationBillit)="openModalTermOperator($event)"
        (loading)="setLoading($event)">
      </app-billet-wks-confirmation>
    </div>
  </ng-container>
  <div *ngIf="showWarningMessage" class="h-100 d-flex flex-column warning-message">
    <span class="font-weight-bold">Atenção:</span>
    <p class="text-justify">{{ padWarning }}</p>
    <mat-checkbox class="mb-1" [(ngModel)]="messageAccept">Concordo</mat-checkbox>
    <button mat-button mat-stroked-button [disabled]="!messageAccept" class="confirmation-btn"
      (click)="showWarningMessage = false">OK</button>
  </div>
</div>
